/* 
Site global JS, as a rule of thumb, 
this should only contain JS that is 
needed for the majority of pages on the site.
*/
import './resource_v1';

(function($){
	

	// vanilla JavaScript external links in new tab.
	var externalLinksNewTab = function() {
        var links = document.links;

        for (var i = 0, linksLength = links.length; i < linksLength; i++) {
            if (links[i].hostname != window.location.hostname) {
                links[i].target = '_blank';
            } else if ( links[i].href.indexOf(".pdf") != -1 ) {
                links[i].target = '_blank';
            }
        }
	};


	var navOpen = false;

	var closeNav = function(){
		$('.site-header').removeClass( 'nav-open' );
		$('body').removeClass( 'nav-open-body' );
		$( '#nav-toggler-button span' ).text( 'MENU'); 
		navOpen = false;
	};

	var openNav = function(){
		$('.site-header').addClass( 'nav-open' );
		$('body').addClass( 'nav-open-body' );
		$( '#nav-toggler-button span' ).text( 'Close'); 
		navOpen = true;
	};

	$(document).ready(function(){
        // here we go
		externalLinksNewTab();

		let siteHeader = $( 'nav.site-header' )[0];
		siteHeader.locked = false
		var headerScrolled = function () {

			if ( $('body').hasClass( 'fl-builder-edit' ) ) {
				// we aren't locking during beaver builder.
				$( siteHeader ).removeClass( 'locked-header' );
				return;
			}

			if ( siteHeader.heroLocked ) {
				return;
			}

			var st = $(this).scrollTop();
			var wHeight = window.innerHeight;
			if ( st > 0 && ! siteHeader.locked ) {
				// lock the header
				$( siteHeader ).addClass( 'locked-header' );
				siteHeader.locked = true;
			} else if (st == 0) {
				$( siteHeader ).removeClass( 'locked-header' );
				siteHeader.locked = false;
			}
			if ( st > ( wHeight - 100 ) || ( $(window).width() < 768 && st > 10 ) ) {
				$( siteHeader ).addClass( 'white-header' );
			} else {
				$( siteHeader ).removeClass( 'white-header' );
			}
		};

		if ( !window.waitingOnTeaser ) {
			$(window).on('scroll', headerScrolled);
		} else {
			$( window ).on('heroDone', function(){
				$(window).on('scroll', headerScrolled);
			});
		}


		$( 'body').on( 'click', '.scroll-link a.nav-link', function( e ){
			e.preventDefault();
			let target = new URL( this.href );
			console.log( target.hash.substring(1) ); //eslint-disable-line
			let scrollTarget = document.getElementsByName( target.hash.substring(1) );
			if ( scrollTarget ) {

				// Dynamically calculate the header height
				const headerHeight = 84;// document.querySelector('.site-header').offsetHeight;
				
				// Calculate the absolute top position of the target element
				const elementPosition = scrollTarget[0].getBoundingClientRect().top;
				
				// Subtract header height from current scroll position
				const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

				// Scroll smoothly to the offset coordinate
				window.scrollTo({
					top: offsetPosition,
					behavior: 'smooth'
				});
				closeNav();
				// scrollTarget[0].scrollIntoView({ 
				// 	behavior: 'smooth',
				// 	block: 'start' // Aligns the top of the element to the top of the viewport
				// });
			} else {
				location.href = target.href;
				return true;
			}
		} );

		// var delta = 5;
		// var lastScrollTop;
		// var hasScrolled = function () {
		// 	var st = $(this).scrollTop();
		// 	console.log( st ); //eslint-disable-line

			
			
		// 	// Make sure they scroll more than delta
		// 	if ( Math.abs(lastScrollTop - st) <= delta || navOpen ) {
		// 		return;
		// 	}
		// 	var header = $('.site-header');

		// 	// console.log( lastScrollTop );
		// 	// If they scrolled down and are past the navbar, add class .nav-up.
		// 	// This is necessary so you never see what is "behind" the navbar.
		// 	var topDiff = 50;
		// 	if ( ! st ) {
		// 		header.removeClass('nav-down').removeClass('nav-up');
		// 	} 
			
		// 	if ( $( 'body' ).hasClass( 'fl-builder-edit' ) ) {
		// 		header.removeClass('nav-down').removeClass('nav-up');
		// 		return;
		// 	}
		// 	//  if ( st > lastScrollTop && st > navbarHeight + 100 ) {
		// 	if ( st > lastScrollTop && st > topDiff ) { 
		// 		// Scroll Down
		// 		header.removeClass('nav-down').addClass('nav-up');
		// 	} else {
		// 		// Scroll Up 
		// 		if ( st === 0 || st < 0 ) {
		// 			header.removeClass('nav-down').removeClass('nav-up');
		// 		} else {
		// 			header.removeClass('nav-up').addClass('nav-down');
		// 		}
		// 	}
			
			
		// 	lastScrollTop = st;
		// };


		// hasScrolled();
		// $( window ).on( 'scroll', hasScrolled );
		
		$( '#nav-toggler-button' ).on( 'click', function( e ){
			e.preventDefault();


			if ( !navOpen ) {
				openNav();
			} else  {
				closeNav();
			}
		} );
	});
	
})(jQuery);

// import './nav';